import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import "./components.css";
import { useTranslation } from "react-i18next";

export default function CheckboxComponent(props) {
  const { t } = useTranslation();
  const { name, label, title, value, onChange, disabled } = props;
  return (
    <div>
      {label && <span className="titleClassName">{t(label)}</span>}
      <div
        className="checkBoxComponentDiv">
      <Checkbox
        style={{
          width: "fit-content",
          paddingLeft: "0px",
          paddingBottom: "10px",
          color: disabled ? "gray" : "#00634a",
        }}
        sx={{
          "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
            fontSize: "18px",
            width: "25px",
            height: "25px",
            '@media (max-width: 800px)': {
              fontSize: "16px",
              width: "20px",
              height: "20px"
            }
          },
          "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
            fontSize: "18px",
            width: "25px",
            height: "25px",
            '@media (max-width: 800px)': {
              fontSize: "16px",
              width: "20px",
              height: "20px"
            }
          },
        }}
        value={value}
        checked={value}
        onChange={(e) => onChange(e)}
        disabled={disabled}
      />
      <span
        className="checkboxLabelClassName"
        style={{ color: disabled ? "gray" : "black" }}
      >
         {name==="PrivacyPolicy" ?(<>{t("I/We have read and accepted the terms of the")} <a target="_blank" rel="noreferrer" href='https://www.bondstreetmortgageq.com/PrivacyPolicy.html'> {t("Privacy Policy")}</a></>):(t(name))}
      </span>
      </div>
    </div>
  );
}
